// Copied from jira/src/packages/navigation-apps/sidebar/utils/src/utils/extract-data/types.tsx

export var Permissions = /*#__PURE__*/function (Permissions) {
  Permissions["MANAGE"] = "manage";
  Permissions["CAN_INVITE_USERS"] = "invite-users";
  return Permissions;
}({});
export var Product = /*#__PURE__*/function (Product) {
  Product["BITBUCKET"] = "bitbucket";
  Product["CONFLUENCE"] = "confluence";
  Product["HOME"] = "home";
  Product["JIRA"] = "jira";
  Product["SITE_ADMIN"] = "site-admin";
  Product["TRELLO"] = "trello";
  Product["START"] = "start";
  return Product;
}({});

// The product keys need to match registered products in Flight Deck:
// https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/

// those product keys are only used internally in the app

//TODO: Clean up/find a better way to do this

export var AnalyticsItemType = /*#__PURE__*/function (AnalyticsItemType) {
  AnalyticsItemType["PRODUCT"] = "product";
  AnalyticsItemType["ADMIN"] = "admin";
  AnalyticsItemType["TRY"] = "try";
  AnalyticsItemType["JOIN"] = "join";
  AnalyticsItemType["CUSTOM_LINK"] = "customLink";
  AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
  AnalyticsItemType["OVERFLOW"] = "overflow";
  return AnalyticsItemType;
}({});
export var ProductKey = /*#__PURE__*/function (ProductKey) {
  ProductKey["CONFLUENCE"] = "confluence.ondemand";
  ProductKey["JIRA_CORE"] = "jira-core.ondemand";
  ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
  ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
  ProductKey["BITBUCKET"] = "bitbucket";
  ProductKey["OPSGENIE"] = "opsgenie";
  ProductKey["STATUSPAGE"] = "statuspage";
  ProductKey["TRELLO"] = "trello";
  ProductKey["COMPASS"] = "compass";
  ProductKey["TEAM_CENTRAL"] = "townsquare";
  ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
  return ProductKey;
}({});